export const { WLODEV_CLOUD } = process.env

export const wlodevS3Path = '/_wlodev/s3'
export const wlodevImagePath = '/_wlodev/image'
export const wlodevAccessPath = '/_wlodev/auth'
export const wlodevRefreshPath = '/_wlodev/auth/refresh'

export const wlodevHostHeader = 'X-Wlodev-Forwarded-Host'
export const wlodevSchemeHeader = 'X-Wlodev-Forwarded-Scheme'

// Cast env string to boolean
export const wlodevCloudEnabled =
    // @ts-ignore
    WLODEV_CLOUD === 'true' || WLODEV_CLOUD === true
